import React from 'react'
import Title from '../../../../../../components/typography/title.component.jsx'
import Container from '../../../../../../components/layout/container.component.jsx'
import CreationForm from '../../components/creation-form.component'
import AccordionSecondary from '../../../../../../components/accordion/accordion-secondary.component.jsx'
import { routes } from '../../../../../../constants/routes.constants'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { toastActions } from '../../../../../../actions/toast.actions'
import { CouponService } from '../../../../../../services/coupon.service'
import { bindActionCreators } from 'redux'
import { Creators as SiteCreators } from '../../../../../../ducks/site/site'

class CouponCreationPageComponent extends React.Component {
	render() {
		return (
			<Container>
				<Title>Inclusão de cupom de desconto</Title>
				<AccordionSecondary
					arrow={false}
					multiple={false}
					noClickable
					noAnimated
					items={getAccordionItems.call(this)}
				/>
			</Container>
		)
	}
}

function getAccordionItems() {
	return [
		{
			title: 'Dados do Cupom',
			content: (
				<CreationForm
					ref={'form'}
					onSubmit={handleSubmit.bind(this)}
					history={this.props.history}
				/>
			)
		}
	]
}

function handleSubmit(values) {
	const { showLoading, hideLoading, history, success } = this.props
	showLoading()
	CouponService.create(values).then(({ errors, ...data }) => {
		hideLoading()
		if (data.success) {
			success({ message: 'Cupom incluído com sucesso' })
			history.push(`${routes.ADMIN}/cupons-de-desconto`)
		}
	})
}

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			...SiteCreators,
			...toastActions
		},
		dispatch
	)

const connectedCouponCreationPageComponent = withRouter(
	connect(
		null,
		mapDispatchToProps
	)(CouponCreationPageComponent)
)

export { connectedCouponCreationPageComponent as ModuleRootComponent }
